<script>
  import { Router, Route } from "svelte-navigator";
  import Header from "./components/Header.svelte";
  import Home from "./components/Home.svelte";
  import Roadmap from "./components/Roadmap.svelte";
  import Buy from "./components/Buy.svelte";
  import About from "./components/About.svelte";
  import FAQ from "./routes/FAQ.svelte";
  import Footer from "./components/Footer.svelte";
  import Gallery from "./routes/Gallery.svelte";
</script>

<Router primary={false}>
  <Header />
  <main>
    <!-- Home -->
    <Route path="/">
      <Home />
      <Buy />
      <About />
      <Roadmap />
    </Route>
    <!----------->

    <!-- FAQ -->
    <Route path="/faq">
      <!-- <Faq /> -->
      <FAQ />
    </Route>
    <!----------->

    <!-- FAQ -->
    <Route path="/gallery">
      <!-- <Faq /> -->
      <Gallery />
    </Route>
    <!----------->
  </main>
  <Footer />
</Router>

<svelte:head>
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    html {
      height: auto;
      scroll-behavior: smooth;
    }
    body {
      background-color: #131114;
      color: #ffffff;

      padding: 0;
      margin: 0;

      flex-shrink: 0;
      flex-grow: 0;
      font-family: "Montserrat", sans-serif;
      background-color: #131114;
      height: auto;
    }

    body.noscroll {
      overflow: hidden;
    }

    a {
      text-decoration: none;
    }

    a:hover {
      text-decoration: none;
    }

    ul {
      list-style: none;
    }
  </style>
</svelte:head>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;1,300;1,700&display=swap");

  main {
    text-align: center;
    padding: 1em;
    margin: 0 auto;
    max-width: 1200px;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }
</style>
